import React, { useState, useEffect } from 'react';
import { OGPDisplay } from './OGPDisplay.js';

const OGPLoad = ({
  url,
  image_height = '200'
}) => {
  const [ogp, setOgp] = useState(null);
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        const res = await fetch(`/api/ogp?url=${encodeURIComponent(url)}`, {
          signal: ac.signal
        });
        if (res.ok) {
          setOgp(await res.json());
        }
      } catch (e) {
        console.error(e);
      }
    })();
    return () => ac.abort();
  }, [url]);
  return /*#__PURE__*/React.createElement(OGPDisplay, {
    title: (ogp == null ? void 0 : ogp.title) || url,
    description: (() => {
      try {
        return new URL(url).hostname + ' / ' + ((ogp == null ? void 0 : ogp.content) || '');
      } catch (e) {
        return (ogp == null ? void 0 : ogp.content) || url;
      }
    })(),
    image: ogp == null ? void 0 : ogp.image_url,
    url: url,
    image_height: image_height
  });
};

export { OGPLoad, OGPLoad as default };
